export function rebaseUrl(baseUrl: string, url: string): string {
  if (!url || url.startsWith(baseUrl)) {
    return url;
  }

  let path = url;

  try {
    const absoluteUrl = new URL(url);
    path = `${absoluteUrl.pathname}${absoluteUrl.search}${absoluteUrl.hash}`;
  } catch {
    // Relative API links only need to be joined to the configured base URL.
  }

  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
